
var Transport;
module.exports = Transport = function Transport(options) {
    this.options = options;
}

Transport.supported = function() {
    return true;
};

Transport.prototype = {
    constructor: Transport,

    send: function(params, callback) {
        throw new Error('Each transport should implement .send');
    }
}